var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var FinishesComponent = /** @class */ (function (_super) {
    __extends(FinishesComponent, _super);
    function FinishesComponent(injector, translateService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.translateService = translateService;
        _this.reasons = [];
        _this.reasons2 = [];
        _this.reasons3 = [];
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        return _this;
    }
    FinishesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reasons = this.getReasons();
        this.reasons2 = this.getReasons2();
        this.reasons3 = this.getReasons3();
        this.subscription.add(this.translateService.onLangChange
            .subscribe(function () {
            _this.reasons = _this.getReasons();
            _this.reasons2 = _this.getReasons2();
            _this.reasons3 = _this.getReasons3();
        }));
        this.setTitle('Detalii proiect Romanescu Park Residence');
        this.setMetaDescription("\n      Romanescu Park Residence va cuprinde 4 faze de dezvoltare, cl\u0103dirile av\u00E2nd un regim de\n      \u00EEn\u0103l\u021Bime de tipul parter + 4 etaje. Cele 4 cl\u0103diri ce fac parte din prima faz\u0103 a proiectului au\n      denumiri specifice arborilor prezen\u021Bi \u00EEn Parcul Nicolae Romanescu: Stejar, Frasin, Tei, Ar\u021Bar\n    ");
    };
    FinishesComponent.prototype.getReasons = function () {
        var reasons = [];
        var _loop_1 = function (i) {
            var reason = {
                title: '',
                content: '',
                image: {
                    url: ''
                }
            };
            this_1.translateSubscription.add(this_1.translateService.get('pages.downtown_life.finishes.phases.' + i + '.title')
                .subscribe(function (translatedString) {
                reason.title = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('pages.downtown_life.finishes.phases.' + i + '.icon_url')
                .subscribe(function (translatedString) {
                reason.image.url = translatedString;
            }));
            reasons.push(reason);
        };
        var this_1 = this;
        for (var i = 0; i < 4; i++) {
            _loop_1(i);
        }
        return reasons;
    };
    FinishesComponent.prototype.getReasons2 = function () {
        var reasons2 = [];
        var _loop_2 = function (i) {
            var reason = {
                title: '',
                content: '',
                image: {
                    url: ''
                }
            };
            this_2.translateSubscription.add(this_2.translateService.get('pages.downtown_life.finishes.phases2.' + i + '.title')
                .subscribe(function (translatedString) {
                reason.title = translatedString;
            }));
            this_2.translateSubscription.add(this_2.translateService.get('pages.downtown_life.finishes.phases2.' + i + '.icon_url')
                .subscribe(function (translatedString) {
                reason.image.url = translatedString;
            }));
            reasons2.push(reason);
        };
        var this_2 = this;
        for (var i = 0; i < 4; i++) {
            _loop_2(i);
        }
        return reasons2;
    };
    FinishesComponent.prototype.getReasons3 = function () {
        var reasons3 = [];
        var _loop_3 = function (i) {
            var reason = {
                title: '',
                content: '',
                image: {
                    url: ''
                }
            };
            this_3.translateSubscription.add(this_3.translateService.get('pages.downtown_life.finishes.phases3.' + i + '.title')
                .subscribe(function (translatedString) {
                reason.title = translatedString;
            }));
            this_3.translateSubscription.add(this_3.translateService.get('pages.downtown_life.finishes.phases3.' + i + '.icon_url')
                .subscribe(function (translatedString) {
                reason.image.url = translatedString;
            }));
            reasons3.push(reason);
        };
        var this_3 = this;
        for (var i = 0; i < 3; i++) {
            _loop_3(i);
        }
        return reasons3;
    };
    return FinishesComponent;
}(SeoAwareBaseComponent));
export { FinishesComponent };



// WEBPACK FOOTER //
// ./src/app/downtown-life/finishes.component.ts.pre-build-optimizer.js